<template>
    <div
        class="border-b border-slate-200 dark:border-slate-700 mb-6"
        role="tablist"
        aria-label="Benefits view tabs"
    >
        <div class="flex gap-6">
            <button
                v-for="tab in tabs"
                :key="tab.id"
                type="button"
                role="tab"
                :aria-selected="modelValue === tab.id"
                class="relative px-1 pb-3 text-sm font-medium transition-colors focus:outline-none"
                :class="
                    modelValue === tab.id
                        ? 'text-orange'
                        : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'
                "
                @click="$emit('update:modelValue', tab.id)"
            >
                {{ tab.label }}
                <span
                    v-if="modelValue === tab.id"
                    class="absolute -bottom-px left-0 right-0 h-0.5 bg-orange rounded-full"
                />
            </button>
        </div>
    </div>
</template>

<script setup>
defineProps({
    modelValue: {
        type: String,
        required: true,
    },
});

defineEmits(['update:modelValue']);

const tabs = [
    { id: 'current', label: 'Current' },
    { id: 'insights', label: 'Insights' },
];
</script>
